<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M325.5 64C342.5 64 358.7 70.8 370.7 82.8L493.3 205.2C505.3 217.2 512 233.5 512 250.4L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128C128 92.7 156.7 64 192 64L325.5 64zM192 96C174.3 96 160 110.3 160 128L160 512C160 529.7 174.3 544 192 544L448 544C465.7 544 480 529.7 480 512L480 256L384 256C348.7 256 320 227.3 320 192L320 96L192 96zM387.1 314.2C392.3 307.1 402.3 305.5 409.4 310.7C416.5 315.9 418.1 325.9 412.9 333L307.3 478.2C304.5 482 300.2 484.4 295.5 484.7C290.8 485 286.2 483.3 282.9 479.9L228.5 423.6C222.4 417.2 222.5 407.1 228.9 401C235.3 394.9 245.4 395.1 251.5 401.4L292.7 444L387.1 314.2zM352 192C352 209.7 366.3 224 384 224L466.7 224L352 109.2L352 192z"
      fill="currentColor"
    />
  </svg>
</template>
